import axiosInstance from './axiosInstance'; 

const API_URL = 'https://idealonline.com.tr/service/idealonline/v1/';

export const fetchPublicationByIssueYearGroups = async (publicationId, publicationType, status) => {
  try {
    const response = await axiosInstance.get(
      `publicationSearch/publicationIdAndPublicationTypeByIssueYearGroups/${publicationId}/${publicationType}/${status}`
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching publication by issue year groups:', error);
    throw error;
  }
};

export const fetchPublicationByIssueList = async (publicationId, publicationType, year, status, page = 1, newPageSize = 100) => {
  try {
    const response = await axiosInstance.get(
      `publicationSearch/publicationIdAndPublicationTypeAndYearByIssueList/${publicationId}/${publicationType}/${year}/${status}`,
      {
        params: { page, newpagesize: newPageSize },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching publication by issue list:', error);
    throw error;
  }
};

export const fetchPublicationByPublicationList = async (publicationId, publicationType, status, page = 1, newPageSize = 10) => {
  try {
    const response = await axiosInstance.get(
      `publicationSearch/publicationIdAndPublicationTypeByPublicationList/${publicationId}/${publicationType}/${status}`,
      {
        params: { page, newpagesize: newPageSize },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching publication by publication list:', error);
    throw error;
  }
};
